export const FEEDBACK_LOOKUP_SURVEY_QUESTIONS = 'FEEDBACK_LOOKUP_SURVEY_QUESTIONS';
export const FEEDBACK_STORE_SURVEY_QUESTION = 'FEEDBACK_STORE_SURVEY_QUESTION';
export const FEEDBACK_SAVE_QUESTION_RESPONSE = 'FEEDBACK_SAVE_QUESTION_RESPONSE';
